var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStakingMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 500 500",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4522 433.685L122.242 433.685L122.242 433.685L122.242 488.769L122.242 488.769L43.4522 488.769L43.4522 488.769L43.4522 433.685L43.4522 433.685Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.13 378.716L230.92 378.716L230.92 378.716L230.92 490.116L230.92 490.116L152.13 490.116L152.13 490.116L152.13 378.716L152.13 378.716Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.808 308.816L339.597 308.816L339.597 308.816L339.597 491.462L339.597 491.462L260.808 491.462L260.808 491.462L260.808 308.816L260.808 308.816Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M372.01 245.566L450.799 245.566L450.799 245.566L450.799 491.477L450.799 491.477L372.01 491.477L372.01 491.477L372.01 245.566L372.01 245.566Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M364.722 109.212L335.004 135.952L398.14 140.121L398.14 140.121L240.178 254.512L109.722 253.959L43.4665 313.594L43.4665 341.667C43.6225 341.54 43.7926 341.412 43.9486 341.27L115.082 277.255L244.9 277.609L409.937 157.347L407.569 216.599L437.301 189.859L440.307 114.174L364.722 109.212Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M244.843 182.146L244.843 206.334L221.59 206.334L221.59 183.804C205.682 183.081 190.27 178.814 181.253 173.596L188.37 145.835C198.338 151.293 212.346 156.284 227.744 156.284C241.27 156.284 250.528 151.066 250.528 141.567C250.528 132.549 242.943 126.85 225.39 120.923C200.011 112.388 182.685 100.52 182.685 77.5087C182.685 56.6238 197.402 40.2619 222.781 35.2711L222.781 12.7274L246.034 12.7274L246.034 33.6122C261.928 34.3353 272.604 37.6531 280.431 41.4387L273.554 68.2502C267.372 65.6413 256.469 60.1968 239.384 60.1968C223.972 60.1968 218.996 66.8323 218.996 73.482C218.996 81.3085 227.304 86.2993 247.466 93.8848C275.709 103.838 287.081 116.896 287.081 138.249C287.066 159.375 272.122 177.396 244.843 182.146Z",
    fill: "#ffffff",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingMenu);
export default __webpack_public_path__ + "static/media/stakingMenu.ec68286b36e3b541ca080c14fbea7fd3.svg";
export { ForwardRef as ReactComponent };